import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'
import dayjs from 'dayjs'
import '@/assets/icons/index'
import '@/directive'
import './assets/style/default.scss'
import YearDatePicker from './components/date-picker/index'
import fontSize from '@/utils/font'
import fontSizes from '@/utils/font'

import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import axios from 'axios'
import VueClipboard from 'v-clipboard'
Vue.use(VueClipboard)
Vue.prototype.$axios = axios
/* leaflet icon */
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import ElementResizeDetectorMaker from 'element-resize-detector'
Vue.prototype.$erd = ElementResizeDetectorMaker()

Vue.component('svg-icon', SvgIcon)
import { i18n } from '@/lang'
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value) // 这里会根据选的语言切换Element-ui的语言
})
Vue.use(YearDatePicker)
Vue.prototype.$fontSize = fontSize
Vue.prototype.$fontSizes = fontSizes
Vue.prototype.$dayjs = dayjs
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.imgUrl = 'https://mock.udantech.com/udan-ems-api/upload'
// 引入组件
// Vue.component(DatePicker.name, DatePicker)

// new Vue({
//   router,
//   store,
//   i18n,
//   render: (h) => h(App)
// }).$mount('#app')

//设置定时器，每5分钟更新token

var vue = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
export default vue
